import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = { class: "row mx-n2" }
const _hoisted_5 = { class: "col-lg-8 px-2" }
const _hoisted_6 = { class: "inner-wrap pt-0 pb-0" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "row mx-n2 align-items-center" }
const _hoisted_9 = { class: "col-sm-4 px-2" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_12 = { "aria-label": "breadcrumb" }
const _hoisted_13 = { class: "breadcrumb mb-0" }
const _hoisted_14 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-home" })
  ])
], -1)
const _hoisted_15 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_16 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active"
}
const _hoisted_17 = { class: "col-sm-8 text-sm-right mt-3" }
const _hoisted_18 = { class: "button-header inline-items mt-0" }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_20 = {
  id: "useTemplate",
  class: "mr-0"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-th-large",
  "data-il8n": "Use template"
}, null, -1)
const _hoisted_22 = { class: "card" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = {
  class: "form-group control-with-icon mb-0",
  id: "projectList"
}
const _hoisted_26 = { class: "col-md-8" }
const _hoisted_27 = { class: "inline-items text-md-right" }
const _hoisted_28 = {
  class: "form-group control-with-icon mb-0",
  id: "projectStatus"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "control-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-check" })
], -1)
const _hoisted_30 = {
  class: "to-upper",
  value: "active"
}
const _hoisted_31 = {
  class: "to-upper",
  value: "archive"
}
const _hoisted_32 = {
  class: "to-upper",
  value: "hidden"
}
const _hoisted_33 = { class: "mr-0" }
const _hoisted_34 = {
  class: "form-group control-with-icon mb-0",
  id: "projectSortBy"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "control-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-check-double" })
], -1)
const _hoisted_36 = { value: "asc" }
const _hoisted_37 = { value: "desc" }
const _hoisted_38 = { value: "def" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 0,
  class: "success-load"
}
const _hoisted_42 = {
  key: 1,
  class: "card"
}
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "col-lg-4 px-2" }
const _hoisted_45 = { class: "card p-0" }
const _hoisted_46 = {
  class: "dashboard-aside p-3",
  id: "projectDetailsDashboard"
}
const _hoisted_47 = { class: "mid-section pt-0 pb-0" }
const _hoisted_48 = { class: "row mx-n2" }
const _hoisted_49 = { class: "col-sm-6 px-2 mb-3" }
const _hoisted_50 = { class: "info-box h-100" }
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "icons-type-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-project-diagram" })
], -1)
const _hoisted_52 = { class: "to-upper" }
const _hoisted_53 = { class: "col-sm-6 px-2 mb-3" }
const _hoisted_54 = { class: "info-box h-100" }
const _hoisted_55 = /*#__PURE__*/_createVNode("div", { class: "icons-type-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-comments" })
], -1)
const _hoisted_56 = { class: "to-upper" }
const _hoisted_57 = { class: "orange" }
const _hoisted_58 = { class: "col-sm-6 px-2 mb-3" }
const _hoisted_59 = { class: "info-box h-100" }
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "icons-type-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-check" })
], -1)
const _hoisted_61 = { class: "orange" }
const _hoisted_62 = { class: "col-sm-6 px-2 mb-3" }
const _hoisted_63 = { class: "info-box h-100" }
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "icons-type-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-users" })
], -1)
const _hoisted_65 = { class: "to-upper" }
const _hoisted_66 = { class: "blue" }
const _hoisted_67 = {
  id: "projectAcknowledgeChannel",
  class: "dashboard-aside"
}
const _hoisted_68 = { class: "mid-section pt-0" }
const _hoisted_69 = { class: "side-card-head" }
const _hoisted_70 = { class: "card-title to-upper" }
const _hoisted_71 = {
  key: 0,
  class: "activity-block custom-scroll fixed-height-activity"
}
const _hoisted_72 = { class: "p-3" }
const _hoisted_73 = { class: "channel-group-wrap" }
const _hoisted_74 = {
  key: 1,
  class: "p-3 text-center"
}
const _hoisted_75 = { class: "to-upper" }
const _hoisted_76 = { class: "to-upper" }
const _hoisted_77 = {
  key: 0,
  id: "recentChannel",
  class: "dashboard-aside"
}
const _hoisted_78 = { class: "mid-section pt-0" }
const _hoisted_79 = { class: "side-card-head" }
const _hoisted_80 = { class: "card-title" }
const _hoisted_81 = { class: "activity-block custom-scroll fixed-height-activity" }
const _hoisted_82 = { class: "p-3" }
const _hoisted_83 = { class: "channel-group-wrap" }
const _hoisted_84 = {
  key: 1,
  id: "activityFeeds",
  class: "dashboard-aside"
}
const _hoisted_85 = { class: "mid-section pt-0" }
const _hoisted_86 = { class: "side-card-head" }
const _hoisted_87 = { class: "row align-items-center" }
const _hoisted_88 = { class: "col-6" }
const _hoisted_89 = { class: "card-title" }
const _hoisted_90 = { class: "col-6" }
const _hoisted_91 = { class: "text-right" }
const _hoisted_92 = {
  key: 0,
  class: "activity-block custom-scroll fixed-height-activity p-3"
}
const _hoisted_93 = { class: "feed-block" }
const _hoisted_94 = { class: "modal-wrap default-modal" }
const _hoisted_95 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "createProject",
  tabindex: -1,
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_96 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_97 = { class: "modal-content" }
const _hoisted_98 = { class: "modal-header" }
const _hoisted_99 = { class: "d-block" }
const _hoisted_100 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_101 = { class: "text-muted" }
const _hoisted_102 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_103 = { class: "modal-body" }
const _hoisted_104 = { class: "form-wrap pt-0" }
const _hoisted_105 = { class: "mb-3" }
const _hoisted_106 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "(*)", -1)
const _hoisted_107 = { class: "form-group" }
const _hoisted_108 = { for: "exampleInputEmail1" }
const _hoisted_109 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_110 = { class: "form-group" }
const _hoisted_111 = { for: "exampleInputEmail1" }
const _hoisted_112 = { class: "form-group" }
const _hoisted_113 = { for: "exampleInputEmail1" }
const _hoisted_114 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_115 = { class: "form-group" }
const _hoisted_116 = { for: "projectAddress" }
const _hoisted_117 = { class: "modal-footer" }
const _hoisted_118 = { class: "modal-wrap default-modal" }
const _hoisted_119 = {
  class: "modal fade",
  id: "inviteMember",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_120 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_121 = { class: "modal-content" }
const _hoisted_122 = { class: "modal-header" }
const _hoisted_123 = { class: "d-block" }
const _hoisted_124 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_125 = { class: "text-muted" }
const _hoisted_126 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_127 = { class: "modal-body" }
const _hoisted_128 = { class: "form-wrap pt-0" }
const _hoisted_129 = { class: "form-group" }
const _hoisted_130 = { for: "exampleInputEmail1" }
const _hoisted_131 = /*#__PURE__*/_createVNode("input", {
  type: "email",
  class: "form-control",
  id: "exampleInputEmail1",
  "aria-describedby": "emailHelp",
  placeholder: "Invite member"
}, null, -1)
const _hoisted_132 = { class: "modal-footer" }
const _hoisted_133 = { class: "modal-body" }
const _hoisted_134 = /*#__PURE__*/_createVNode("span", { class: "animating-arrow" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-right" })
], -1)
const _hoisted_135 = { key: 2 }
const _hoisted_136 = /*#__PURE__*/_createVNode("div", { class: "custom-modal-overlay" }, null, -1)
const _hoisted_137 = { class: "custom-modal" }
const _hoisted_138 = { class: "custom-modal-dialog" }
const _hoisted_139 = { class: "custom-modal-content" }
const _hoisted_140 = { class: "custom-modal-header" }
const _hoisted_141 = { class: "custom-modal-title" }
const _hoisted_142 = /*#__PURE__*/_createVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_143 = { class: "custom-modal-body p-3" }
const _hoisted_144 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_145 = { class: "custom-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UpgradeSubscriptionModal = _resolveComponent("UpgradeSubscriptionModal")
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_ProjectCard = _resolveComponent("ProjectCard")
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_DiscussionChannels = _resolveComponent("DiscussionChannels")
  const _component_RecentChannels = _resolveComponent("RecentChannels")
  const _component_ActivityCard = _resolveComponent("ActivityCard")
  const _component_router_link = _resolveComponent("router-link")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_GoogleMapView = _resolveComponent("GoogleMapView")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", null, [
    ((_ctx.state.postLoading && !_ctx.state.ui.isLoading.projectListAPICalled) || _ctx.state.allProjectLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("p", _hoisted_3, _toDisplayString(_ctx.state.msg), 1),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("h1", _hoisted_10, _toDisplayString(_ctx.$t("my_projects")), 1),
                _createVNode("div", _hoisted_11, [
                  _createVNode("nav", _hoisted_12, [
                    _createVNode("ol", _hoisted_13, [
                      _hoisted_14,
                      _createVNode("li", _hoisted_15, [
                        _createVNode("a", _hoisted_16, _toDisplayString(_ctx.$t("dashboard")), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _createVNode("a", {
                        id: "createNewProject",
                        href: "javascript:void(0)",
                        class: "btn default-btn",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToCreateProject && _ctx.redirectToCreateProject(...args)))
                      }, [
                        _hoisted_19,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('create_project')), 1)
                      ])
                    ]),
                    _createVNode("li", _hoisted_20, [
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        class: "btn default-btn outline",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToUseTemplate && _ctx.redirectToUseTemplate(...args)))
                      }, [
                        _hoisted_21
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.state.ui.isActive.upgradeSubscription)
            ? (_openBlock(), _createBlock(_component_UpgradeSubscriptionModal, {
                key: 0,
                onCloseModal: _ctx.hideUpdateSubscriptionModal
              }, null, 8, ["onCloseModal"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_22, [
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _createVNode(_component_multiselect, {
                    modelValue: _ctx.projectSelected,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.projectSelected = $event)),
                    options: _ctx.allProjectLists,
                    "close-on-select": "true",
                    onSelect: _cache[4] || (_cache[4] = ($event: any) => (_ctx.redirectToProjectDetails('false'))),
                    "clear-on-select": true,
                    placeholder: _ctx.$t('search_and_select'),
                    label: "name",
                    "track-by": "name"
                  }, null, 8, ["modelValue", "options", "placeholder"])
                ])
              ]),
              _createVNode("div", _hoisted_26, [
                _createVNode("div", _hoisted_27, [
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _createVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _withDirectives(_createVNode("select", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.project.status = $event)),
                          onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.changeProjectByStatus && _ctx.changeProjectByStatus(...args)))
                        }, [
                          _createVNode("option", _hoisted_30, _toDisplayString(_ctx.$t("active")), 1),
                          _createVNode("option", _hoisted_31, _toDisplayString(_ctx.$t("archived")), 1),
                          _createVNode("option", _hoisted_32, _toDisplayString(_ctx.$t("hidden")), 1)
                        ], 544), [
                          [_vModelSelect, _ctx.state.data.project.status]
                        ])
                      ])
                    ]),
                    _createVNode("li", _hoisted_33, [
                      _createVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _withDirectives(_createVNode("select", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.project.sort = $event)),
                          onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.changeProjectByStatus && _ctx.changeProjectByStatus(...args)))
                        }, [
                          _createVNode("option", _hoisted_36, _toDisplayString(_ctx.$t('a_to_z')), 1),
                          _createVNode("option", _hoisted_37, _toDisplayString(_ctx.$t('z_to_a')), 1),
                          _createVNode("option", _hoisted_38, _toDisplayString(_ctx.$t('most_active')), 1)
                        ], 544), [
                          [_vModelSelect, _ctx.state.data.project.sort]
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        (_ctx.state.data.projectLoad)
          ? (_openBlock(), _createBlock("div", _hoisted_39, [
              (_ctx.state.projectList && _ctx.state.projectList.length)
                ? (_openBlock(), _createBlock("div", _hoisted_40, [
                    _createVNode(_component_ProjectCard, {
                      projectList: _ctx.state.projectList,
                      channelLimit: _ctx.state.data.subscriptionDetails.channel_per_project,
                      onCustomChannel: _ctx.channelInsert,
                      onSelectedProject: _ctx.selectedProject,
                      onUpdateProjectDetails: _ctx.updateProjectDetails,
                      onUpdateProjectList: _ctx.updateProjectList,
                      onShowUpgrade: _ctx.hideUpdateSubscriptionModal,
                      onShowCustomModal: _ctx.showCustomModal,
                      onActiveProjectId: _ctx.setActiveProjectId
                    }, null, 8, ["projectList", "channelLimit", "onCustomChannel", "onSelectedProject", "onUpdateProjectDetails", "onUpdateProjectList", "onShowUpgrade", "onShowCustomModal", "onActiveProjectId"]),
                    (_ctx.state.projectCount > _ctx.state.projectList.length && _ctx.state.projectCount > 6)
                      ? (_openBlock(), _createBlock("div", _hoisted_41, [
                          _createVNode("a", {
                            href: "javascript:void(0)",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.loadMoreProjectList && _ctx.loadMoreProjectList(...args)))
                          }, _toDisplayString(_ctx.state.postLoading ? "loading..." : "load more"), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_42, [
                    _createVNode(_component_EmptyData, {
                      title: _ctx.state.title,
                      heading: _ctx.state.heading
                    }, null, 8, ["title", "heading"])
                  ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.postLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_43, [
              _createVNode("p", null, _toDisplayString(_ctx.$t('loading')) + "...", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_44, [
        _createVNode("div", _hoisted_45, [
          _createVNode("div", _hoisted_46, [
            _createVNode("div", _hoisted_47, [
              _createVNode("div", _hoisted_48, [
                _createVNode("div", _hoisted_49, [
                  _createVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _createVNode("h5", _hoisted_52, _toDisplayString(_ctx.$t("total")) + " " + _toDisplayString(_ctx.$t('projects')), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.state.totalProjects), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_53, [
                  _createVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createVNode("h5", _hoisted_56, _toDisplayString(_ctx.$t('total')) + " " + _toDisplayString(_ctx.$t('channels')), 1),
                    _createVNode("p", _hoisted_57, _toDisplayString(_ctx.state.totalChannels), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_58, [
                  _createVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createVNode("h5", null, _toDisplayString(_ctx.$t(_ctx.state.projectCountName)), 1),
                    _createVNode("p", _hoisted_61, _toDisplayString(_ctx.state.projectCount), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_62, [
                  _createVNode("div", _hoisted_63, [
                    _hoisted_64,
                    _createVNode("h5", _hoisted_65, _toDisplayString(_ctx.$t('total')) + " " + _toDisplayString(_ctx.$t('members')), 1),
                    _createVNode("p", _hoisted_66, _toDisplayString(_ctx.state.totalUsers), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_67, [
            _createVNode("div", _hoisted_68, [
              _createVNode("div", _hoisted_69, [
                _createVNode("h3", _hoisted_70, _toDisplayString(_ctx.$t('project')) + " " + _toDisplayString(_ctx.$t('discussion')) + " " + _toDisplayString(_ctx.$t('channels')), 1)
              ]),
              (_ctx.state.data.payerChannels && _ctx.state.data.payerChannels.length
              )
                ? (_openBlock(), _createBlock("div", _hoisted_71, [
                    _createVNode("div", _hoisted_72, [
                      _createVNode("div", _hoisted_73, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                      .payerChannels, (activity, activityIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "channel-card-wrap",
                            key: activityIndex
                          }, [
                            _createVNode(_component_DiscussionChannels, { activity: activity }, null, 8, ["activity"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_74, [
                    _createVNode("p", _hoisted_75, _toDisplayString(_ctx.$t('no_project_discussion_channels_yet')), 1),
                    _createVNode("h5", _hoisted_76, _toDisplayString(_ctx.$t('total')) + " " + _toDisplayString(_ctx.$t('channels')), 1)
                  ]))
            ])
          ]),
          (_ctx.state.data.recentChannels && _ctx.state.data.recentChannels.length)
            ? (_openBlock(), _createBlock("div", _hoisted_77, [
                _createVNode("div", _hoisted_78, [
                  _createVNode("div", _hoisted_79, [
                    _createVNode("h3", _hoisted_80, _toDisplayString(_ctx.$t('recent')) + " " + _toDisplayString(_ctx.$t('channels')), 1)
                  ]),
                  _createVNode("div", _hoisted_81, [
                    _createVNode("div", _hoisted_82, [
                      _createVNode("div", _hoisted_83, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                      .recentChannels, (activity, activityIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "channel-card-wrap",
                            key: activityIndex
                          }, [
                            _createVNode(_component_RecentChannels, { activity: activity }, null, 8, ["activity"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.data.activities && _ctx.state.data.activities.length)
            ? (_openBlock(), _createBlock("div", _hoisted_84, [
                _createVNode("div", _hoisted_85, [
                  _createVNode("div", _hoisted_86, [
                    _createVNode("div", _hoisted_87, [
                      _createVNode("div", _hoisted_88, [
                        _createVNode("h3", _hoisted_89, _toDisplayString(_ctx.$t('activity')) + " " + _toDisplayString(_ctx.$t('project')), 1)
                      ]),
                      _createVNode("div", _hoisted_90, [
                        _createVNode("div", _hoisted_91, [
                          _createVNode("a", {
                            href: "javascript:void(0)",
                            class: "green-btn",
                            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.projectListActivities && _ctx.projectListActivities(...args)))
                          }, _toDisplayString(_ctx.state.ui.isLoading.projectListActivities
                          ? _ctx.$t('loading1')
                          : _ctx.$t('see_more')), 1)
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.state.data.activities && _ctx.state.data.activities.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_92, [
                        _createVNode("div", _hoisted_93, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.activities, (activity, activityIndex) => {
                            return (_openBlock(), _createBlock("div", { key: activityIndex }, [
                              _createVNode(_component_ActivityCard, { activity: activity }, null, 8, ["activity"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_94, [
      _createVNode("div", _hoisted_95, [
        _createVNode("div", _hoisted_96, [
          _createVNode("div", _hoisted_97, [
            _createVNode("div", _hoisted_98, [
              _createVNode("div", _hoisted_99, [
                _createVNode("h5", _hoisted_100, _toDisplayString(_ctx.$t('create_project')), 1),
                _createVNode("p", _hoisted_101, _toDisplayString(_ctx.$t('create_project_collaboration')), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.hideCreateProjectModal && _ctx.hideCreateProjectModal(...args))),
                "aria-label": "Close"
              }, [
                _createVNode(_component_router_link, { to: "/dashboard" }),
                _hoisted_102
              ])
            ]),
            _createVNode("div", _hoisted_103, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.errorList,
                hasError: _ctx.state.isErrorStatus
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_104, [
                _createVNode("p", _hoisted_105, [
                  _createTextVNode(_toDisplayString(_ctx.$t('note')) + " " + _toDisplayString(_ctx.$t('fields_marked_with')) + " ", 1),
                  _hoisted_106,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('are_mandatory')), 1)
                ]),
                _createVNode("div", _hoisted_107, [
                  _createVNode("label", _hoisted_108, [
                    _createTextVNode(_toDisplayString(_ctx.$t('project_name')) + " ", 1),
                    _hoisted_109
                  ]),
                  _withDirectives(_createVNode("input", {
                    type: "email",
                    class: "form-control",
                    id: "exampleInputEmail1",
                    "aria-describedby": "emailHelp",
                    placeholder: _ctx.$t('project_name_placeholder'),
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.projectName = $event))
                  }, null, 8, ["placeholder"]), [
                    [_vModelText, _ctx.state.projectName]
                  ])
                ]),
                _createVNode("div", _hoisted_110, [
                  _createVNode("label", _hoisted_111, _toDisplayString(_ctx.$t('project_description')), 1),
                  _withDirectives(_createVNode("textarea", {
                    class: "form-control",
                    name: "",
                    id: "",
                    cols: "30",
                    rows: "10",
                    placeholder: _ctx.$t('project_description_placeholder'),
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.state.projectDescription = $event))
                  }, null, 8, ["placeholder"]), [
                    [_vModelText, _ctx.state.projectDescription]
                  ])
                ]),
                _createVNode("div", _hoisted_112, [
                  _createVNode("label", _hoisted_113, _toDisplayString(_ctx.$t('project_tags')), 1),
                  _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedOptions,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectedOptions = $event)),
                    "tag-placeholder": "Add this as new tag",
                    placeholder: _ctx.$t('project_tags_placeholder'),
                    label: "name",
                    "track-by": "code",
                    options: _ctx.options,
                    multiple: true,
                    taggable: true,
                    onTag: _ctx.addTag
                  }, null, 8, ["modelValue", "placeholder", "options", "onTag"])
                ]),
                _hoisted_114,
                _createVNode("div", _hoisted_115, [
                  _createVNode("label", _hoisted_116, _toDisplayString(_ctx.$t('project_address')), 1),
                  _createVNode(_component_GoogleMapView, {
                    latitude: _ctx.latitude,
                    longitude: _ctx.longitude,
                    address: _ctx.address,
                    visible: _ctx.showMap,
                    isEdit: true,
                    "onUpdate:latitude": _ctx.updateLatitude,
                    "onUpdate:longitude": _ctx.updateLongitude,
                    "onUpdate:address": _ctx.updateAddress
                  }, null, 8, ["latitude", "longitude", "address", "visible", "onUpdate:latitude", "onUpdate:longitude", "onUpdate:address"])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_117, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.createProject && _ctx.createProject(...args)))
              }, _toDisplayString(_ctx.state.postLoadingCreateProject ? _ctx.$t('creating') : _ctx.$t('create')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_118, [
      _createVNode("div", _hoisted_119, [
        _createVNode("div", _hoisted_120, [
          _createVNode("div", _hoisted_121, [
            _createVNode("div", _hoisted_122, [
              _createVNode("div", _hoisted_123, [
                _createVNode("h5", _hoisted_124, _toDisplayString(_ctx.$t('invite_member')), 1),
                _createVNode("p", _hoisted_125, _toDisplayString(_ctx.$t('create_project_collaboration')), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.hideInvite && _ctx.hideInvite(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_126
              ])
            ]),
            _createVNode("div", _hoisted_127, [
              _createVNode("div", _hoisted_128, [
                _createVNode("div", _hoisted_129, [
                  _createVNode("label", _hoisted_130, _toDisplayString(_ctx.$t('invite_member')), 1),
                  _hoisted_131
                ])
              ])
            ]),
            _createVNode("div", _hoisted_132, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.hideInvite && _ctx.hideInvite(...args)))
              }, _toDisplayString(_ctx.$t('done')), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 1,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.SuccessFulMessage,
          subTitleMessage: _ctx.state.data.subTitleMessage,
          isButton: _ctx.state.data.isProjectCreated
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_133, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn mr-2 mb-2",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.redirectToProjectDetails('true')))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('continue_to_create_channel')) + " ", 1),
                _hoisted_134
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose", "showModal", "titleMessage", "subTitleMessage", "isButton"]))
      : _createCommentVNode("", true),
    (_ctx.state.ui.isActive.customModal)
      ? (_openBlock(), _createBlock("div", _hoisted_135, [
          _hoisted_136,
          _createVNode("div", _hoisted_137, [
            _createVNode("div", _hoisted_138, [
              _createVNode("div", _hoisted_139, [
                _createVNode("div", _hoisted_140, [
                  _createVNode("h2", _hoisted_141, _toDisplayString(_ctx.$t('project_archive')), 1),
                  _createVNode("button", {
                    class: "custom-modal-close",
                    onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.hideCustomModal && _ctx.hideCustomModal(...args)))
                  }, [
                    _hoisted_142
                  ])
                ]),
                _createVNode("div", _hoisted_143, [
                  _createVNode("div", _hoisted_144, _toDisplayString(_ctx.$t('archive_project_confirmation')), 1)
                ]),
                _createVNode("div", _hoisted_145, [
                  _createVNode("button", {
                    class: "btn default-btn mr-2",
                    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.projectRestore && _ctx.projectRestore(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.projectArchive ? _ctx.$t('loading1') : _ctx.$t('archive1')), 1),
                  _createVNode("button", {
                    class: "btn btn-danger to-upper",
                    onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.hideCustomModal && _ctx.hideCustomModal(...args)))
                  }, _toDisplayString(_ctx.$t('no')), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}